import { Injectable, DOCUMENT, inject } from '@angular/core';

import { InteractivityChecker } from '@angular/cdk/a11y';

@Injectable({
  providedIn: 'root'
})
export class FocusService {
  protected readonly document = inject(DOCUMENT);
  private readonly interactivityChecker = inject(InteractivityChecker);

  shiftFocus(element: HTMLElement): void {
    element.focus();
  }

  isDisabled(element: HTMLElement): boolean {
    return this.interactivityChecker.isDisabled(element);
  }
}
